import Transfer from '../views/otherSettings/transfer.vue'

export default [
  {
    path: '/otherSettings/transfer',
    name: 'Transfer',
    component: Transfer,
  }
]